import { Backdrop, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const DownloadBackdrop = ({ downloading,text }) =>{
return(
<Backdrop
  open={downloading}
  sx={{
    color: "#fff",
    zIndex: 3010,
    flexDirection: "column",
  }}
>
  <CircularProgress color="inherit" />
  <Box mt={2}>{text ? text : "Downloading your memory..."}</Box>
</Backdrop>
)
}
export default DownloadBackdrop;